var app = angular.module("leonardo");

var AdminAccountRejectDialogController = function($scope, AccountService, AccountRequestService) {

  $scope.submit = function() {
    var service = $scope.isRequest ? AccountRequestService : AccountService;
    service.reject($scope.ngDialogData.account).then(function() {
      $scope.confirm();
    }, function () {
      $scope.closeThisDialog();
    });
  };
};


app.controller('AdminAccountRejectDialogController', ['$scope', 'AccountService', 'AccountRequestService',
  AdminAccountRejectDialogController]);
